<template>
  <div class="floating-container">
    <!-- 垂直按钮组 -->
    <div class="button-group">
      <!-- Live Chat 按钮 -->
      <div 
        class="floating-btn live-chat" 
        @click="openLiveChat"
      >
        <i class="el-icon-chat-line-square"></i>
        <span>{{ $t('app.floatingContact.liveChat') }}</span>
      </div>

      <!-- WhatsApp 按钮（触发二维码） -->
      <div 
        class="floating-btn whatsapp" 
        @mouseenter="handleQRShow" 
        @mouseleave="handleQRHide"
      >
        <i class="el-icon-phone"></i>
        <span>{{ $t('app.floatingContact.wechat') }}</span>
      </div>

      <!-- FB Group 按钮 -->
      <div 
        class="floating-btn fb-group" 
        @click="openFBGroup"
      >
        <i class="el-icon-share"></i>
        <span>{{ $t('app.floatingContact.facebook') }}</span>
      </div>
    </div>

    <!-- 二维码弹窗（鼠标移入时显示） -->
    <transition name="qr-fade">
      <div 
        class="qr-popup" 
        v-show="showQR"
      >
        <img 
          :src="qrCodeUrl" 
          alt="WhatsApp QR" 
          class="qr-img"
        />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FloatingContact',
  data() {
    return {
      showQR: false,
      timer: null, // 用于延迟隐藏的定时器
      qrCodeUrl: require('@/assets/images/app/wechat.png') // 替换为实际二维码路径
    }
  },
  methods: {
    // 鼠标移入：立即显示二维码
    handleQRShow() {
      clearTimeout(this.timer)
      this.showQR = true
    },
    // 鼠标移出：延迟200ms隐藏（避免快速移入移出闪烁）
    handleQRHide() {
      this.timer = setTimeout(() => {
        this.showQR = false
      }, 200)
    },
    // 打开Live Chat（示例：跳转外部链接）
    openLiveChat() {
      window.open('https://your-live-chat-url.com', '_blank')
    },
    // 打开FB Group（示例：跳转外部链接）
    openFBGroup() {
      window.open('https://www.facebook.com/your-group', '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
// 容器：固定在右下角，层级置顶
.floating-container {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  // 按钮组：垂直排列
  .button-group {
    display: flex;
    flex-direction: column;
    align-items: center;

    // 通用按钮样式
    .floating-btn {
      width: 64px;
      height: 64px;
      margin: 8px 0;
      border-radius: 50%;
      background-color: #28a745; // ElementUI成功色
      color: #fff;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;

      i {
        font-size: 22px;
        margin-bottom: 4px;
      }

      &:hover {
        transform: scale(1.05); // 轻微放大效果
      }
    }

    // 按钮差异化样式
    .live-chat {
      background-color: #409EFF; //  ElementUI primary 色
      &:hover {
        background-color: #66b1ff;
      }
    }
    .whatsapp {
      background-color: #25d366; // WhatsApp 品牌绿
      &:hover {
        background-color: #128c7e;
      }
    }
    .fb-group {
      background-color: #3b5998; // Facebook 品牌蓝
      &:hover {
        background-color: #5474b8;
      }
    }
  }

  // 二维码弹窗：绝对定位在按钮左侧
  .qr-popup {
    position: absolute;
    right: calc(100% + 16px); // 与按钮间距16px
    bottom: 50%;
    transform: translateY(50%); // 垂直居中
    background: #fff;
    padding: 12px;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.2);
    transition: all 0.3s ease;

    .qr-img {
      width: 140px;
      height: 140px;
      display: block;
    }
  }

  // 过渡动画（可选，让显示/隐藏更平滑）
  .qr-fade-enter-active, .qr-fade-leave-active {
    opacity: 1;
    transform: translateX(0);
  }
  .qr-fade-enter, .qr-fade-leave-to {
    opacity: 0;
    transform: translateX(10px);
  }
}

// 响应式调整：手机端缩小间距
@media (max-width: 768px) {
  .floating-container {
    right: 12px;
    bottom: 12px;
  }
  .qr-popup {
    right: calc(100% + 8px);
    padding: 8px;
    .qr-img {
      width: 100px;
      height: 100px;
    }
  }
}
</style>